import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { FC } from "react";
import { getString } from "../../../utils/Validator";

const useStyles = makeStyles((theme) => ({
  filesListItem: {
    position: "relative",
    width: "100%",
    maxWidth: 410,
    listStyle: "none",
    display: "flex",
    alignItems: "center",
    marginLeft: 0,
  },
  fileListItemPreview: {
    border: "1px solid #CCC",
    borderRadius: 5,
  },
  fileListName: {
    margin: theme.spacing(0, 1),
  },
  listFile: {
    width: 75,
    flexGrow: 0,
    height: 75,
  },
  fileButton: {
    position: "absolute",
    right: 5,
  },
}));

interface FileUploadFragmentInterface {
  file: any;
  isMultiple: boolean;
  handleRemove(): void;
  disabled?: boolean;
}

const FileUploadFragment: FC<FileUploadFragmentInterface> = (props) => {
  const { file, isMultiple, handleRemove, disabled } = props;
  const classes = useStyles();
  return (
    <Box component="li" className={classes.filesListItem}>
      <Box className={classes.fileListItemPreview}>
        {file.preview.type === "image" && (
          <img className={classes.listFile} src={file.preview.url} />
        )}
      </Box>
      <Typography className={classes.fileListName}>
        {getString(file.name, false)}
      </Typography>{" "}
      :
      <IconButton
        aria-label="delete"
        className={classes.fileButton}
        onClick={handleRemove}
        disabled={disabled}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};

export default FileUploadFragment;
